import withModal from './with-modal';

export default withModal;
